
import helper from '../helper';

const smothScrollTo = function() {
    let elements = document.querySelectorAll('.wp-block-hayyabuild-godown > a, .wp-block-hayyabuild-goup > a')
    if ( ! elements ) return


    Math.easeInOutQuad = (t, b, c, d) => {
        t /= d/2
        if (t < 1) return c/2*t*t + b
        t--
        return -c/2 * (t*(t-2) - 1) + b
    }

    const scrollTo = (to, duration) => {
        const element = document.scrollingElement
        const start = (element && element.scrollTop) || window.pageYOffset
        const change = to - start
        const increment = 20
        let currentTime = 0

        const animateScroll = function(){
            currentTime += increment
            const val = Math.easeInOutQuad(currentTime, start, change, duration)
            window.scrollTo(0, val)
            if(currentTime < duration) {
                window.setTimeout(animateScroll, increment)
            }
        }
        animateScroll()
    }

    elements.forEach( el => {
        el.addEventListener('click', event => {
            event.preventDefault()
            let target = document.querySelector(el.hash)
            let targetOffset = target ? target.offsetTop : 0

            scrollTo(targetOffset, 500)
        })
    })

}

export default smothScrollTo;
